import { IconContentLayoutIcon } from '@doltech/icons/IconContentLayoutIcon';
import { IconContentLayoutList } from '@doltech/icons/IconContentLayoutList';
import { IconContentLayoutListCheck } from '@doltech/icons/IconContentLayoutListCheck';
import { IconContentLayoutNum } from '@doltech/icons/IconContentLayoutNum';
import { IconContentLayoutX } from '@doltech/icons/IconContentLayoutX';
import cl from 'classnames';
import * as React from 'react';
import { useSlateStatic } from 'slate-react';
import styled from 'styled-components';

import { colorsV2 } from '../../../../colors-v2';
import { MarkButton } from '../../BlogEditorToolbar/components/MarkButton';
import {
  ELEMENT_BULLET_POINT,
  ELEMENT_BULLET_POINT_CHECK,
  ELEMENT_BULLET_POINT_NUMBER,
  ELEMENT_BULLET_POINT_QUESTION,
  ELEMENT_BULLET_POINT_X,
} from '../BulletPointPlugin.types';
import { BulletPointTransformActions } from '../model/transforms';

const LIST_SWITCHER_POPOVER_HEIGHT = 48;
const LIST_SWITCHER_POPOVER_WIDTH = 208;

const Main = styled.div`
  position: absolute;
  left: calc(50% - ${LIST_SWITCHER_POPOVER_WIDTH / 2}px);
  bottom: -${LIST_SWITCHER_POPOVER_HEIGHT + 8}px;
  display: grid;
  place-items: center;
  transition: all 0.2s ease;
  opacity: 0;
  pointer-events: none;
  z-index: -1;

  transform: translateY(${LIST_SWITCHER_POPOVER_HEIGHT / 2}px);

  &.visible {
    opacity: 1;
    pointer-events: auto;
    z-index: 10;
    transform: translateY(0);
  }

  .list-switcher-container {
    display: grid;
    grid-auto-flow: column;
    gap: 8px;
    background-color: ${colorsV2.white100};
    box-shadow: 0 15px 40px rgba(28, 28, 33, 0.16);
    border-radius: 8px;
    padding: 8px;
  }
`;

interface ListSwitcherPopOverProps {}

export const ListSwitcherPopOver = (props: ListSwitcherPopOverProps) => {
  const editor = useSlateStatic();
  const activeType = BulletPointTransformActions.currentActiveBulletPoint(editor);

  return (
    <Main contentEditable={false} className={cl('list-switcher-popover', 'visible')}>
      <div className="list-switcher-container">
        <MarkButton
          onMouseDown={(e) => {
            e.preventDefault();
            BulletPointTransformActions.toggleListElement(editor, { type: ELEMENT_BULLET_POINT });
          }}
          active={activeType === ELEMENT_BULLET_POINT}
          icon={<IconContentLayoutList />}
        />
        <MarkButton
          onMouseDown={(e) => {
            e.preventDefault();
            BulletPointTransformActions.toggleListElement(editor, {
              type: ELEMENT_BULLET_POINT_NUMBER,
            });
          }}
          active={activeType === ELEMENT_BULLET_POINT_NUMBER}
          icon={<IconContentLayoutNum />}
        />
        <MarkButton
          onMouseDown={(e) => {
            e.preventDefault();
            BulletPointTransformActions.toggleListElement(editor, {
              type: ELEMENT_BULLET_POINT_CHECK,
            });
          }}
          active={activeType === ELEMENT_BULLET_POINT_CHECK}
          icon={<IconContentLayoutListCheck />}
        />
        <MarkButton
          onMouseDown={(e) => {
            e.preventDefault();
            BulletPointTransformActions.toggleListElement(editor, { type: ELEMENT_BULLET_POINT_X });
          }}
          active={activeType === ELEMENT_BULLET_POINT_X}
          icon={<IconContentLayoutX />}
        />
        <MarkButton
          onMouseDown={(e) => {
            e.preventDefault();
            BulletPointTransformActions.toggleListElement(editor, {
              type: ELEMENT_BULLET_POINT_QUESTION,
            });
          }}
          active={activeType === ELEMENT_BULLET_POINT_QUESTION}
          icon={<IconContentLayoutIcon />}
        />
      </div>
    </Main>
  );
};
